(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fg-collection-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCollectionGuide() {
      var trigger = document.querySelector('[data-fg-guide]');
      if (!trigger || trigger.dataset.fgReady) return;
      trigger.dataset.fgReady = '1';

      var teaser = trigger.querySelector('[data-fg-guide-teaser]');
      var lb = document.querySelector('[data-fg-guide-lb]');
      var full = lb.querySelector('[data-fg-guide-full]');
      var lastFocus = null;

      var conn = navigator.connection || {};
      var cheap = conn.saveData === true || /^([23]g|slow-2g)$/.test(conn.effectiveType || '');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Ambient loop inside the circle is unsolicited motion, so it respects
      // reduced motion and data saving. The poster still shows in that case.
      if (!cheap && !reduce && teaser && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              if (!teaser.getAttribute('src') && teaser.dataset.src) teaser.src = teaser.dataset.src;
              var p = teaser.play();
              if (p && p.catch) p.catch(function () {});
              obs.disconnect();
            }
          });
        }, { threshold: 0.4 });
        io.observe(trigger);
      }

      function open() {
        lastFocus = document.activeElement;
        if (!full.getAttribute('src')) full.src = trigger.dataset.src;
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
        var p = full.play();
        if (p && p.catch) p.catch(function () {});
        lb.querySelector('.fg-cglb__x').focus();
      }

      function close() {
        full.pause();
        lb.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      }

      trigger.addEventListener('click', open);
      lb.querySelectorAll('[data-fg-guide-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lb.hidden) close();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCollectionGuide);
    } else {
      initCollectionGuide();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fg-frontpage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var home = document.querySelector('.fg-home');
    if (!home) return;

    var saveData = navigator.connection && navigator.connection.saveData;

    // Hero video: the poster carries the first paint, so the video is attached
    // and started once the page has loaded and the browser is idle. Skipped on
    // Save-Data (data cost is real); reduced-motion does NOT skip it — that
    // gate quietly blanked the hero for everyone with the OS setting on, which
    // read as "the video is broken". The film is calm, muted and decorative.
    var hero = home.querySelector('[data-hero-src]');
    if (hero && !saveData) {
      var startHero = function () {
        if (hero.dataset.lit) return;
        hero.dataset.lit = '1';
        var s = document.createElement('source');
        s.src = hero.dataset.heroSrc;
        s.type = 'video/mp4';
        hero.appendChild(s);
        hero.load();
        var pp = hero.play();
        if (pp && pp.catch) pp.catch(function () {});
      };
      var queueHero = function () {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(startHero, { timeout: 2500 });
        } else {
          window.setTimeout(startHero, 300);
        }
      };
      if (document.readyState === 'complete') queueHero();
      else window.addEventListener('load', queueHero);
    }

    // Trustpilot's bootstrap scans the page once on load. If that pass already
    // ran, our widget stays an empty shell, so render it explicitly. The
    // bootstrap normally arrives with the Trustpilot app, but this section owns
    // its widget, so load the script ourselves if the app ever stops doing it.
    var tp = home.querySelector('[data-fg-tp]');
    if (tp) {
      var TP_BOOTSTRAP = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      if (!window.Trustpilot && !document.querySelector('script[src="' + TP_BOOTSTRAP + '"]')) {
        var s = document.createElement('script');
        s.src = TP_BOOTSTRAP;
        s.async = true;
        document.head.appendChild(s);
      }
      var tpTries = 0;
      (function renderTp() {
        if (window.Trustpilot && window.Trustpilot.loadFromElement) {
          window.Trustpilot.loadFromElement(tp, true);
        } else if (tpTries++ < 25) {
          window.setTimeout(renderTp, 300);
        }
      })();
    }

    // Hover teaser videos on knife tiles (desktop, pointer:fine)
    var tiles = home.querySelectorAll('.fg-tcard');
    Array.prototype.forEach.call(tiles, function (tile) {
      var vid = tile.querySelector('.fg-vt__vid');
      if (!vid) return;
      function load() {
        if (!vid.getAttribute('src') && vid.dataset.src) vid.src = vid.dataset.src;
      }
      // Teaser videos are a desktop affordance only: on a pointer device the
      // tile plays its clip on hover. On touch there is no autoplay — several
      // clips starting at once as the rail scrolled felt chaotic — so the play
      // button, which opens the guide film in the lightbox, is the only way to
      // start a video there.
      if (window.matchMedia('(hover: hover)').matches && !saveData) {
        tile.addEventListener('mouseenter', function () {
          load();
          tile.classList.add('fg-playing');
          var p = vid.play();
          if (p && p.catch) p.catch(function () {});
        });
        tile.addEventListener('mouseleave', function () {
          tile.classList.remove('fg-playing');
          vid.pause();
        });
      }
    });

    // Curated picks drawer. One panel below the tile row; the tiles act as
    // tabs into it, and clicking the open one closes the drawer again.
    var picks = home.querySelector('[data-fg-picks]');
    if (picks) {
      var pickBtns = home.querySelectorAll('[data-fg-pick]');
      var sets = picks.querySelectorAll('.fg-picks__set');

      function moveNotch(btn) {
        var b = btn.getBoundingClientRect();
        var p = picks.getBoundingClientRect();
        // Clamp so a tile scrolled to the rail's edge still keeps the notch
        // inside the tray rather than poking past its rounded corner.
        var x = b.left - p.left + b.width / 2;
        x = Math.max(18, Math.min(x, p.width - 18));
        picks.style.setProperty('--fg-pick-x', x + 'px');
      }

      function closePicks() {
        picks.hidden = true;
        pickBtns.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          b.parentNode.classList.remove('is-open');
        });
      }

      function openPicks(handle, btn) {
        var found = false;
        sets.forEach(function (s) {
          var match = s.getAttribute('data-set') === handle;
          s.hidden = !match;
          if (match) found = true;
        });
        if (!found) return;
        picks.hidden = false;
        pickBtns.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-expanded', on ? 'true' : 'false');
          b.parentNode.classList.toggle('is-open', on);
        });
        moveNotch(btn);
        // On the horizontally scrolling mobile rail, ease the open tile toward
        // the centre so the tray's pointer has it in view, then re-measure once
        // the scroll settles.
        if (window.matchMedia('(max-width: 899px)').matches && btn.parentNode.scrollIntoView) {
          btn.parentNode.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          window.setTimeout(function () { moveNotch(btn); }, 340);
        }
      }

      // A browser never loads images inside a hidden subtree, so switching tab
      // would show four empty boxes for a beat. Fetching them into cache on
      // hover means they are already there by the time the tab is clicked.
      function warm(handle) {
        var set = picks.querySelector('.fg-picks__set[data-set="' + handle + '"]');
        if (!set || set.dataset.warm) return;
        set.dataset.warm = '1';
        set.querySelectorAll('img').forEach(function (img) {
          var pre = new Image();
          if (img.getAttribute('sizes')) pre.sizes = img.getAttribute('sizes');
          if (img.getAttribute('srcset')) pre.srcset = img.getAttribute('srcset');
          pre.src = img.getAttribute('src');
        });
      }

      pickBtns.forEach(function (btn) {
        var handle = btn.getAttribute('data-fg-pick');
        ['mouseenter', 'focus', 'touchstart'].forEach(function (evt) {
          btn.addEventListener(evt, function () { warm(handle); }, { passive: true });
        });
        btn.addEventListener('click', function () {
          if (btn.getAttribute('aria-expanded') === 'true') {
            closePicks();
          } else {
            openPicks(handle, btn);
          }
        });
      });

      // The notch is positioned in pixels, so it has to be re-measured
      // whenever the row reflows.
      var openBtn = home.querySelector('[data-fg-pick][aria-expanded="true"]');
      if (openBtn) moveNotch(openBtn);
      function reNotch() {
        var cur = home.querySelector('[data-fg-pick][aria-expanded="true"]');
        if (cur) moveNotch(cur);
      }
      window.addEventListener('resize', reNotch);
      // The mobile rail scrolls under the tray, so the notch has to keep up.
      var typeRail = home.querySelector('.fg-g3');
      if (typeRail) {
        typeRail.addEventListener('scroll', function () {
          window.requestAnimationFrame(reNotch);
        }, { passive: true });
      }
    }

    // Lightbox
    var lb = document.getElementById('fg-lb');
    var lbVideo = document.getElementById('fg-lb-video');
    var lbName = document.getElementById('fg-lb-name');
    var lbCta = document.getElementById('fg-lb-cta');
    var lastFocus = null;

    function openLb(src, name, ctaText, href) {
      lastFocus = document.activeElement;
      lbVideo.src = src;
      lbName.textContent = name || '';
      // No href means there is nowhere to send people (the steel films have no
      // collection of their own), so the CTA is hidden rather than dangling.
      if (href) {
        lbCta.textContent = ctaText || 'Se alle';
        lbCta.setAttribute('href', href);
        lbCta.hidden = false;
      } else {
        lbCta.hidden = true;
      }
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
      var p = lbVideo.play();
      if (p && p.catch) p.catch(function () {});
      lb.querySelector('.fg-lb__x').focus();
    }
    function closeLb() {
      lbVideo.pause();
      lbVideo.removeAttribute('src');
      lbVideo.load();
      lb.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    home.querySelectorAll('[data-lb-src]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openLb(btn.dataset.lbSrc, btn.dataset.lbName, btn.dataset.lbCta, btn.dataset.lbHref);
      });
    });
    lb.querySelectorAll('[data-lb-close]').forEach(function (el) {
      el.addEventListener('click', closeLb);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lb.hidden) closeLb();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fg-knivguide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.fg-kg');
    if (!root) return;
    var lb = root.querySelector('[data-kg-lb]');
    var video = root.querySelector('[data-kg-video]');
    var title = root.querySelector('[data-kg-title]');
    var cta = root.querySelector('[data-kg-cta]');
    var last = null;

    function open(btn) {
      last = btn;
      video.src = btn.getAttribute('data-kg-src');
      title.textContent = btn.getAttribute('data-kg-name') || '';
      var href = btn.getAttribute('data-kg-href');
      if (href) {
        cta.href = href;
        cta.textContent = btn.getAttribute('data-kg-cta') || 'Se alle';
        cta.hidden = false;
      } else {
        cta.hidden = true;
      }
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    function close() {
      video.pause();
      // Dropping the source stops the file downloading in the background.
      video.removeAttribute('src');
      video.load();
      lb.hidden = true;
      document.body.style.overflow = '';
      if (last) last.focus();
    }

    root.querySelectorAll('[data-kg-src]').forEach(function (btn) {
      btn.addEventListener('click', function () { open(btn); });
    });
    root.querySelectorAll('[data-kg-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lb.hidden) close();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
